module.exports = __webpack_public_path__ + "img/loading_schedule.d431ac83.svg";